// 帖子管理
import http from "@/jslibs/axios/http";

// 列表
export const page = (data) => http.post("/web/CommunityManager/getPostList", data);

// 删除
export const del = (data) => http.post("/web/CommunityManager/deletePosts", data);

// 详情
export const detail = (data) => http.post("/web/CommunityManager/getPostDetail", data);

// 编辑 
export const edit = (data) => http.post("/web/CommunityManager/postShelfStatusUpdate", data);

// 审核 
export const audit = (data) => http.post("/web/CommunityManager/postAudit", data);

// 批量审核 
export const batchAudit = (data) => http.post("/web/CommunityManager/batchPostAudit", data);

// 置顶推荐配置 
export const postTop = (data) => http.post("/web/CommunityManager/CommunityPostTopUpdate", data);